<template>
    <div class="gdpr-names">
        <div v-if="step == STEP_CURRENT_EMPLOYEES">
            <names-list
                ref="ceList"
                :namesList.sync="names.currentEmployees"
                subTitle="Input the names of your current employees so that DataMapper can find all documents where their names appear.<br>When inserting multiple, separate names by using either comma, semicolon, or new line."
                placeHolder="Insert current employee names"
                optionalStepText=""
                key="ceList"
                @skip="nextStep"></names-list>
        </div>
        <div v-if="step == STEP_FORMER_EMPLOYEES">
            <names-list
                ref="feList"
                :namesList.sync="names.formerEmployees"
                subTitle="Input the names of your former employees so that DataMapper can find all documents where their names appear.<br>When inserting multiple, separate names by using either comma, semicolon, or new line."
                placeHolder="Insert former employee names"
                optionalStepText="Do you want DataMapper to match with former employees?"
                key="feList"
                @skip="nextStep"></names-list>
        </div>
        <div v-if="step == STEP_CURRENT_CUSTOMERS">
            <names-list
                ref="ccList"
                :namesList.sync="names.currentCustomers"
                subTitle="Input the names of your current private customers so that DataMapper can find all documents where their names appear.<br>When inserting multiple, separate names by using either comma, semicolon, or new line."
                placeHolder="Add names of current private customers"
                optionalStepText="Do you want DataMapper to match with current private customers?"
                key="ccList"
                @skip="nextStep"></names-list>
        </div>
        <div v-if="step == STEP_FORMER_CUSTOMERS">
            <names-list
                ref="fcList"
                :namesList.sync="names.formerCustomers"
                subTitle="Input the names of your former private customers so that DataMapper can find all documents where their names appear.<br>When inserting multiple, separate names by using either comma, semicolon, or new line."
                placeHolder="Add names of former private customers"
                optionalStepText="Do you want DataMapper to match with former private customers?"
                key="fcList"
                @skip="nextStep"></names-list>
        </div>
        <div class="bottom-action">
            <button @click="nextStep" class="continue simple">Next</button>
            <button @click="back" v-if="step > 0" class="back simple">Back</button>
        </div>
    </div>
</template>

<script>

import { loading } from '@/account/utils'
import { mapState } from 'vuex'

const config = [
    {
        'title': 'Add names of current employees',
        'titleTooltip': '',
    },
    {
        'title': 'Add names of former employees',
        'titleTooltip': '',
    },
    {
        'title': 'Add names of current private customers',
        'titleTooltip': 'Add all names of private B2C customers as well as private persons coming from B2B customers. Do not add B2B customer names.',
    },
    {
        'title': 'Add names of former private customers',
        'titleTooltip': 'Add all names of former private B2C customers as well as private persons coming from B2B customers. Do not add B2B customer names.',
    },
]

module.exports = {

    created () {
        this.$store.commit('updatePageInfo', config[this.step])
    },

    data () {
        return {
            STEP_CURRENT_EMPLOYEES: 0,
            STEP_FORMER_EMPLOYEES: 1,
            STEP_CURRENT_CUSTOMERS: 2,
            STEP_FORMER_CUSTOMERS: 3,
        }
    },

    computed: {
        ...mapState({
            step: state => state.progress.subStep,
            names: state => state.gdprNames,
        }),
    },

    methods: {

        back: loading(function() {
            this.$store.commit('updateSubStep', this.step-1)
            this.$store.commit('updatePageInfo', config[this.step])
            // Some cooldown for the user
            return new Promise((resolve, reject) => setTimeout(() => resolve(), 100))
        }),

        nextStep: loading(function() {
            if (this.step + 1 == config.length) {
                return this.$store.dispatch('updateGDPRNames', this.names).then((res) => {
                    this.$store.commit('updatePageInfo', config[0])
                    this.$store.commit('next')
                })
            }
            this.$store.commit('updateSubStep', this.step+1)
            this.$store.commit('updatePageInfo', config[this.step])
            // Some cooldown for the user
            return new Promise((resolve, reject) => setTimeout(() => resolve(), 100))
        })
    }
}

</script>

<style lang="scss">

    .gdpr-names h1 {
        font-size: 24px;
    }


</style>


// WEBPACK FOOTER //
// apps/account/Names.vue